import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { BellIconComponent } from '../../../@icons/bell-icon.component';


/**
 * Attention banner: surfaces that an item is waiting for a user action (e.g. a manual,
 * blocking growing step that won't auto-advance). Reusable. The host decides when to show it.
 * Usage: `<vw-action-needed-banner [message]="..." [confirmLabel]="..." [dismissLabel]="..."
 *           (confirmed)="..." (dismissed)="..." />`
 * `hint` (optionnel) : ligne d'aide sous le message, qui passe alors en titre 16 px.
 */
@Component({
  selector: 'vw-action-needed-banner',
  standalone: true,
  imports: [BellIconComponent],
  templateUrl: './action-needed-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './action-needed-banner.component.scss',
})
export class ActionNeededBannerComponent {
  @Input() message = '';
  @Input() hint = '';
  @Input() confirmLabel = '';
  @Input() dismissLabel = '';
  @Output() confirmed = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();
}
